const initialState = () => {
    return {
        /**
         * @description
         * This variable contains all the items that are in the cart
         * for a single transaction.
         */
        items: [],
        total: 0,
        neto: 0,
        iva: 0,
        globalDiscount: {
            percentage_discount: null,
            amount_discount: null,
        },

        activeMobileItemId: null,
    }
}

export default initialState
